module.exports = __webpack_public_path__ + "media/banners/remote-11d9f786.png";